import React, {useState, useEffect} from "react";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

export default function SignupToggle(props) {
  const [user, setUser] = useState(() => {
    const url = window.location.href
    if(url.includes("RegisterCollege")) {
      window.localStorage.setItem('userType', 'institutionLogin')
      return 'institutionLogin'
    }
    return window.localStorage.getItem('userType') || "";
  });

  const isMobile = useMediaQuery({query: `(max-width: 769px)`});

  const history = useHistory();
  useEffect(() => {
    let user = window.localStorage.getItem('userType');
    if (user === "institutionLogin" && window.location.pathname !== "/RegisterCollege") {
      history.push({pathname: '/RegisterCollege'});
    } else if (user === "teacherLogin" && window.location.pathname !== "/Register") {
      history.push({pathname: '/TeacherOption'})
    }
  }
  , []);

  const handleChange = (e, newUser) => {
    if (newUser !== null) {
      window.localStorage.setItem('userType', newUser)}
  };

  const toggleButtonStyleLargeScreen = {
    fontSize: "26px", textTransform: "none", width: "170px", height: "70px",
    color: "#79cbca", border: "1px solid #79cbca", lineHeight: "normal", textAlign: "center"
  }
  const toggleButtonStyleSmallScreen = {
    fontSize: "26px", textTransform: "none", width: "170px", height: "70px",
    color: "white", border: "1px solid #79cbca", lineHeight: "normal", textAlign: "center"
  }

  return (
    <ToggleButtonGroup
      value={user}
      exclusive
      onChange={handleChange}
    >
      {
        user === 'teacherLogin'
        ? (
          <ToggleButton
            style={isMobile ? toggleButtonStyleSmallScreen : toggleButtonStyleLargeScreen}
            className={user === 'teacherLogin' ? "btn-primary text-white" : "secondary-button-no-margin-hover"}
            href='/TeacherOption'
            value="teacherLogin">
            {props?.isChildhoodTeacher ? "Educator" : "Teacher"}
          </ToggleButton>
        )
        : (
          <ToggleButton
            style={isMobile ? toggleButtonStyleSmallScreen : toggleButtonStyleLargeScreen}
            className={user === 'institutionLogin' ? "btn-primary text-white" : "secondary-button-no-margin-hover"}
            href='/RegisterCollege'
            value="institutionLogin">
            Institution /
            Provider
          </ToggleButton>
        )
      }
  </ToggleButtonGroup>
  );
}